import cx from 'classnames'
import { RawButton } from '@/components/Button'
import styles from './ContentLabel.module.css'
import type { ReactNode, Ref } from 'react'

interface ContentLabelProps {
  children?: ReactNode
  clickable?: boolean
  iconRight?: ReactNode
  block?: boolean
  /**
   * Optional actions using <ContentLabelAction />
   */
  actions?: ReactNode
  ref?: Ref<HTMLDivElement>
}

/**
 * Content label.
 */
export function ContentLabel({
  children,
  clickable,
  block,
  iconRight,
  actions,
  ref,
}: ContentLabelProps) {
  return (
    <div className={cx(styles.root, block && styles.block)}>
      <div
        className={cx(styles.label, clickable && styles.clickable)}
        ref={ref}
      >
        <div className={styles.text}>{children}</div>
        {iconRight && <span className={styles.icon}> {iconRight}</span>}
      </div>

      <div className={styles.actions}>{actions}</div>
    </div>
  )
}

interface ContentLabelActionProps {
  children?: ReactNode
  to?: string
  href?: string
  onPress?: () => unknown
}

/**
 * Content label action.
 */
export function ContentLabelAction({
  children,
  to,
  href,
  onPress,
}: ContentLabelActionProps) {
  return (
    <RawButton to={to} href={href} className={styles.action} onPress={onPress}>
      {children}
    </RawButton>
  )
}
